import { ItemConfig } from '../request-detail/patient-request-detail.component';

export const defaultPatientConfig: ItemConfig[] = [
  {
    key: 'apellidos',
    span: 3,
  },
  {
    key: 'nombre',
    span: 2,
  },
  {
    key: 'historia',
    span: 2,
  },
  {
    key: 'sexo',
    span: 2,
  },
  {
    key: 'edad',
    span: 1,
  },
  {
    key: 'fechaNac',
    span: 2,
  },
];
